export const headers = {
    headers: {
        'Authorization': `Bearer ${localStorage.getItem("tokenskanpay")}`
    }
}